import ChevronIcon from 'assets/chevron-black.svg?react'
import FlagIcon from 'assets/flag.svg?react'
import clsx from 'clsx'
import { format, isEqual, isWeekend } from 'date-fns'
import { Link } from 'react-router-dom'

import { PATH } from '../../../../../const'
import { Row } from '../../../pages/trade-events'
import classes from '../index.module.scss'

export interface EventNavProps {
  dates: Date[]
  row: Row
  selectedDate: Date
  source: string
  tradeId: string
}

export const EventNav = ({ dates, row, selectedDate, source, tradeId }: EventNavProps) => (
  <nav>
    {dates.map(date => {
      const formattedDate = format(date, 'E d')
      const isEnd = isEqual(date, row.end)
      const isDisabled = isWeekend(date)
      const isSelected = isEqual(date, selectedDate)

      return isDisabled ? (
        <>
          <span className={classes.weekendDate}>{formattedDate}</span>
          {!isEnd && <ChevronIcon className={classes.chevron} />}
        </>
      ) : (
        <>
          <Link
            key={formattedDate}
            className={clsx({ [classes.selected]: isSelected })}
            to={PATH.reportsSingleTradeEventsEvent(source, tradeId, date, row.id)}
          >
            {isEnd && row.isCompleted && <FlagIcon className={classes.flag} />}
            {formattedDate}
          </Link>
          {!isEnd && <ChevronIcon className={classes.chevron} />}
        </>
      )
    })}
  </nav>
)
